import React from 'react'
import styled from 'styled-components'

import { Checkbox } from '../../../input'
import { FONTS } from '../../../../constants'

export const PrivilegeRoleInfo = props => {
  const {
    emp,
    handleCheckbox,
  } = props

  const is_hr_admin_confidential_role = localStorage.getItem('is_hr_admin_confidential_role') === 'true'
  const is_system_admin = localStorage.getItem('is_system_admin') === 'true'

  return (
    <Root>
      <Container>
        <FormGroup>
          <LabelRoleCol>
            <Label>Accounting</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_accountant_role_create'
              name='is_accountant_role'
              checked={ emp.is_accountant_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Subcontractor</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_subcontract_role_create'
              name='is_subcontract_role'
              checked={ emp.is_subcontract_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Project Manager</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_pm_role_create'
              name='is_pm_role'
              checked={ emp.is_pm_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>LOB Lead</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_lob_lead_role_create'
              name='is_lob_lead_role'
              checked={ emp.is_lob_lead_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Management</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_management_role_create'
              name='is_management_role'
              disabled={ !is_hr_admin_confidential_role && !is_system_admin }
              checked={ emp.is_management_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>HR Admin</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_hr_admin_role_create'
              name='is_hr_admin_role'
              checked={ emp.is_hr_admin_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>HR Admin Confidential</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_hr_admin_confidential_role_create'
              name='is_hr_admin_confidential_role'
              disabled={ !is_hr_admin_confidential_role && !is_system_admin }
              checked={ emp.is_hr_admin_confidential_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>HR Subcontract</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_hr_subcontract_role_create'
              name='is_hr_subcontract_role'
              disabled={ !is_hr_admin_confidential_role && !is_system_admin }
              checked={ emp.is_hr_subcontract_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Display Standard Cost</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_vp_avp_role_create'
              name='is_vp_avp_role'
              disabled={ !is_hr_admin_confidential_role && !is_system_admin }
              checked={ emp.is_vp_avp_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Display PPS</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_display_pps_role_create'
              name='is_display_pps_role'
              checked={ emp.is_display_pps_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Project Approver</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_project_approver_role_create'
              name='is_project_approver_role'
              disabled={ !is_hr_admin_confidential_role && !is_system_admin }
              checked={ emp.is_project_approver_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Project Acknowledge</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_project_acknowledge_role_create'
              name='is_project_acknowledge_role'
              disabled={ !is_hr_admin_confidential_role && !is_system_admin }
              checked={ emp.is_project_acknowledge_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Sales</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_salesman_role_create'
              name='is_salesman_role'
              checked={ emp.is_salesman_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Submit Efficiency</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_submit_efficiency_role_create'
              name='is_submit_efficiency_role'
              checked={ emp.is_submit_efficiency_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Not Count Headcount</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_not_count_headcount_create'
              name='is_not_count_headcount'
              checked={ emp.is_not_count_headcount }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
      </Container>
    </Root>
  )
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const Container = styled.div`
    padding: 16px 24px;
    background: #FFFFFF;
    max-height: calc(100vh - 240px);
    overflow-y: scroll;
`

const FormGroup = styled.div`
    display: flex;
    margin-bottom: 16px;
`

const LabelRoleCol = styled.div`
    display: flex;
    flex: 3;
`
const InputCol = styled.div`
    display: flex;
    flex: 2;

    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/create-form/privilege-role/index.js